/* global module, require */
const crel = require('./createElement'),
	empty = require('./emptyElement'),
	entries = require('./objectEntries');

function PlannerOptions(parent) {
	this.name = 'Options';
	this.parent = parent;
	this.planner = parent.planner;
	this.measurements = parent.measurements;
	this.called = false;

	this.container = crel({ className: 'planner-choose-options' });
	this.tip = crel({ className: 'planner-tip-box' });
	this.feedback = {};
}

PlannerOptions.prototype.complete = function() {
	return this.called;
};

PlannerOptions.prototype.activate = function() {
	this.called = true;

	empty(this.parent.content);
	this.parent.content.appendChild(this.container);
	this.rebuildDom();
};

PlannerOptions.prototype.rebuildDom = function() {
	const me = this;
	empty(me.container);

	me.container.appendChild(this.tip);
	me.options = me.planner.style.options;

	function onchange(e) {
		const { name, value } = e.target;
		const { suffix, transform } = me.config[name];
		const feedback = me.feedback[name];
		me.options[name] = transform ? transform(value) : value;

		if (feedback) feedback.innerText = value + suffix;
		me.changed();
	}

	crel({
		_parent: me.container,
		_tag: 'h2',
		innerText: 'Please select your options',
	});
	var inputs = crel({ _parent: me.container, className: 'inputs' });

	me.config = me.planner.style.getConfig();
	entries(me.config).forEach(e => {
		const [name, option] = e;

		if (option.options) {
			const row = crel({ _parent: inputs, className: 'select row' });
			crel({
				_parent: row,
				_tag: 'label',
				innerText: option.name + ':',
			});

			const selectWrapper = crel({ _parent: row, className: 'select-wrapper' });
			const select = crel({
				_parent: selectWrapper,
				_tag: 'select',
				name,
				onchange,
			});

			Object.entries(option.options).forEach(o => {
				const [innerText, value] = o;

				crel({
					_parent: select,
					_tag: 'option',
					value,
					innerText,
					selected: value === me.options[name],
				});
			});

			if (option.info) me.addInfo(row, option.info);
		} else if (option.range) {
			const { min, max } = option.range;
			const value = me.options[name];

			const row = crel({ _parent: inputs, className: 'range row' });
			crel({
				_parent: row,
				_tag: 'label',
				innerText: option.name + ':',
			});

			me.feedback[name] = crel({
				_parent: row,
				_tag: 'span',
				className: 'feedback',
				innerText: value + option.suffix,
			});

			crel({
				_parent: row,
				_tag: 'input',
				type: 'range',
				name,
				min,
				max,
				value,
				onchange,
			});

			if (option.info) me.addInfo(row, option.info);
		}
	});

	me.changed();
};

PlannerOptions.prototype.changed = function() {
	if (this.planner.style.setOptions(this.options)) this.rebuildDom();

	this.measurements.changed();
};

PlannerOptions.prototype.addInfo = function(_parent, _content) {
	const content =
		typeof _content === 'string' ? [crel({ innerText: _content })] : _content;

	return crel({
		_parent,
		className: 'info',
		innerText: 'i',
		onmouseenter: e => {
			const { clientWidth } = this.parent.main;
			const { left, right, width } = e.currentTarget.getClientRects()[0];
			const { offsetTop } = e.currentTarget;
			empty(this.tip);

			content.forEach(el => this.tip.appendChild(el));

			if (window.innerWidth > 450) {
				this.tip.style.top = offsetTop + 'px';
				this.tip.style.left = '';
				this.tip.style.right = clientWidth - right + width + 10 + 'px';
			} else {
				this.tip.style.top = offsetTop - 5 + 'px';
				this.tip.style.left = left + width + 10 + 'px';
				this.tip.style.right = '';
			}

			this.tip.classList.add('show');
		},
		onmouseleave: () => {
			this.tip.classList.remove('show');
		},
	});
};

PlannerOptions.prototype.deactivate = function() {
	this.tip.classList.remove('show');
};

module.exports = PlannerOptions;
